const REQUIRED_ENV_VARS = [
  'VITE_API_SERVER_URL',
  'VITE_WEBSOCKET_URL',
  'VITE_AUTH0_DOMAIN',
  'VITE_AUTH0_CLIENT_ID',
  'VITE_AUTH0_CALLBACK_URL',
  'VITE_AUTH0_AUDIENCE',
  'VITE_PREVIEW_DOMAIN'
] as const;

export function validateEnv(): void {
  const env = import.meta.env as Record<string, string | undefined>;

  const missing = REQUIRED_ENV_VARS.filter((key) => {
    const value = env[key];
    return value === undefined || value === null || value.trim() === '';
  });

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}. ` +
        'Set them in your .env file (see .env.example).'
    );
  }
}
